import { Heading1 } from 'components/shared/Typography.styled';
import { Trans } from 'next-i18next';
import {
  StyledContent,
  StyledHeadingCarousel,
  StyledHeadingCarouselInner,
  StyledHero,
  StyledHeroBg
} from './LaunchHero.styled';
import LaunchHeroScroll from './LaunchHeroScroll';

const Words: React.FC = () => {
  return (
    <StyledHeadingCarousel>
      <StyledHeadingCarouselInner>
        <span className="start">sencillo</span>
        <span aria-hidden="true">estúpido</span>
        <span aria-hidden="true">simple</span>
        <span aria-hidden="true">maldito</span>
        <span aria-hidden="true">ingenuo</span>
        <span aria-hidden="true">sencillo</span>
      </StyledHeadingCarouselInner>
    </StyledHeadingCarousel>
  );
};

const LaunchHero: React.FC = () => {
  return (
    <StyledHero>
      <StyledHeroBg>
        <div></div>
      </StyledHeroBg>
      <StyledContent>
        <Heading1>
          <Trans
            i18nKey={'hero.form'}
            ns="launch-landing"
            components={{
              words: <Words />
            }}
          ></Trans>
        </Heading1>
      </StyledContent>
      <LaunchHeroScroll />
    </StyledHero>
  );
};

export default LaunchHero;
